import { HosterUserModel } from '@/hoster/models/HosterUserModel';
import { Subscription } from '@toilet-paper-games/core';
import { autorun, makeAutoObservable, toJS } from 'mobx';

export class UsersManager {
  usersMap = new Map<string, HosterUserModel>();
  kickedUsers = new Map<string, HosterUserModel>();

  get users() {
    return Array.from(this.usersMap.values());
  }

  get hostUsers() {
    return this.users.filter((user) => user.isHost);
  }

  get connectedUsers() {
    return this.users.filter((user) => user.hasConnection);
  }

  get activeUsers() {
    return this.users.filter((user) => user.active);
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
    this.setupHostManager();
  }

  setupHostManager() {
    return autorun(() => {
      if (this.hostUsers.filter((user) => user.hasConnection).length === 0) {
        const userWithHighestSubscription =
          this.activeUsers.reduce<HosterUserModel | null>((highest, user) => {
            if (!highest) {
              return user;
            }

            const currentUserSubscriptionLevel = subscriptionMap[user.subscription];
            const highestSubscriptionLevel = subscriptionMap[highest.subscription];

            if (currentUserSubscriptionLevel > highestSubscriptionLevel) {
              return user;
            }

            return highest;
          }, null);

        if (userWithHighestSubscription) {
          userWithHighestSubscription.isHost = true;
        }
      }
    });
  }
}

const subscriptionMap: Record<Subscription, number> = {
  [Subscription.Free]: 0,
  [Subscription.Day_Pass]: 1,
};
